import { createSelector } from '@reduxjs/toolkit';
import { selectSearchMetaData } from './selectSearchMetaData';
import { numberToPrettyString, plural } from '@cian/utils';
import { selectIsInlineFiltersRedesigned } from '../redesigned/selectIsInlineFiltersRedesigned';
import { selectPageType } from '../page/selectPageType';
import { EPageType } from 'shared/types/page';

export const selectSearchResultsText = createSelector(
  selectSearchMetaData,
  selectIsInlineFiltersRedesigned,
  selectPageType,
  (searchMeta, isFiltersRedesign, pageType) => {
    const offersCount = searchMeta?.count;

    if (isFiltersRedesign && pageType === EPageType.MAIN) {
      return 'Применить';
    }

    if (typeof offersCount === 'undefined') {
      return 'Показать объекты';
    }

    return `Показать ${numberToPrettyString(offersCount)} ${plural(offersCount, ['объект', 'объекта', 'объектов'])}`;
  },
);
